import css from '../containers/_Full/css';
import { getCompanyColors } from './Api';

export function getUrlParams(search) {
  const urlParams = {};

  if (!search) {
    return urlParams;
  }

  search.slice(1).split('&').forEach((param) => {
    const name = param.split('=')[0];
    const value = param.split('=')[1];
    if (name && value) {
      urlParams[name] = decodeURIComponent(value);
    }
  });

  return urlParams;
}

export function setUrlParams(params) {
  const res = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`);

  window.location.hash = window.location.hash.split('?')[0] + (res.length ? `?${res.join('&')}` : '');
}

export function getTextFromHtml(html) {
  const div = document.createElement('div');
  div.innerHTML = html;

  return div.innerText;
}

export function toHHMMSS(seconds, separator) {
  const pad = input => (input < 10 ? `0${input}` : input);
  return [
    pad(Math.floor(seconds / 3600)),
    pad(Math.floor((seconds % 3600) / 60)),
    pad(Math.floor(seconds % 60)),
  ].join(typeof separator !== 'undefined' ? separator : ':');
}

export function toLocalTime(utcString) {
  const preparedDatetime = new Date(`${utcString}`.replace(/-/g, '/'));
  const localizedDatetime
    = new Date(preparedDatetime.getTime() - (60000 * preparedDatetime.getTimezoneOffset()));

  return utcString ? localizedDatetime.toLocaleString() : '';
}

export const truncString = (str, max) => (
  typeof str === 'string' && str.length > max ? `${str.substring(0, max)}...` : str
);

export const applyCSS = () => {
  function replaceAll(string, search, replace) {
    if (replace === undefined) {
      return string.toString();
    }
    return string.split(search).join(replace);
  }

  let companyColors = { primary_color: '55, 177, 174', secondary_color: '221, 236, 235' };
  // let companyBg = '';
  const companyColorsPromise = getCompanyColors();
  companyColorsPromise.then((newCompanyColors) => {
    localStorage.setItem('colors', JSON.stringify(newCompanyColors.rgb));
    // localStorage.setItem('bg', JSON.stringify(newCompanyColors.bg));
  }).then(() => {
    const localCompanyColors = localStorage.getItem('colors');
    // const localCompanyBg = localStorage.getItem('bg');
    companyColors = (localCompanyColors === 'undefined' || !localCompanyColors)
      ? companyColors
      : JSON.parse(localCompanyColors);
    // companyBg = (localCompanyBg === 'undefined' || !localCompanyBg)
    //   ? companyBg
    //   : JSON.parse(localCompanyBg);
  }).then(() => {
    let style = document.getElementById('company_colors');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute('id', 'company_colors');
    }
    let rCSS = replaceAll(css, 'primary_color', companyColors.primary_color);
    rCSS = replaceAll(rCSS, 'secondary_color', companyColors.secondary_color);
    // rCSS = replaceAll(rCSS, 'company_bg', companyBg);
    style.innerHTML = rCSS;
    document.head.appendChild(style);
  });
};

export const getErrorMessageKey = ({ en }, code) =>
  en && en[`error_code_${code}`]
    ? `error_code_${code}`
    : 'error_code_2494'; // unexpected error



// WEBPACK FOOTER //
// ./src/utils/helper.js